import { siteInfo, footerData, navItems } from '@/mocks/homeData';

export default function Footer() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <span className="text-xl md:text-2xl font-heading font-bold text-primary-400 mb-4 block">
                {siteInfo.name}
              </span>
              <p className="text-sm text-foreground-300 leading-relaxed">
                {footerData.description}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-white mb-4">快速导航</h4>
              <ul className="space-y-2">
                {navItems.slice(0, 4).map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleScroll(item.href); }}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-white mb-4">更多链接</h4>
              <ul className="space-y-2">
                {navItems.slice(4).map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleScroll(item.href); }}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-white mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#footer"
                  onClick={(e) => e.preventDefault()}
                  className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#footer"
                  onClick={(e) => e.preventDefault()}
                  className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#footer"
                  onClick={(e) => e.preventDefault()}
                  className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label="邮箱"
                >
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2026 {siteInfo.name}. 版权所有。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#footer"
                onClick={(e) => e.preventDefault()}
                className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                隐私政策
              </a>
              <a
                href="#footer"
                onClick={(e) => e.preventDefault()}
                className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
              >
                用户协议
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}